import { GetVoicesResponse } from "@next-platform/client-common-core";

import { VoiceItem } from "../components/VoiceSelectionModal/types";

type PlayVoiceSample = (shouldPlay: boolean, onAudioEnded: () => void, audioUrl?: string) => void;

export const transformVoices = (voices: GetVoicesResponse = [], playVoiceSample: PlayVoiceSample): VoiceItem[] => {
  const transformedVoices = voices?.map((voice) => ({
    ...voice,
    ...{
      label: voice?.name,
      subLabel: voice?.description,
      onChange: (shouldPlay: boolean, onAudioEnded: () => void) => playVoiceSample(shouldPlay, onAudioEnded, voice.audio_url),
    },
  }));
  return transformedVoices;
};
